/* istanbul ignore file */
export * from './SearchStructuredData';
